var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_706_141134",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_706_141134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.03338 9.23327L4.85005 12.4166C4.67227 12.5944 4.46116 12.6833 4.21672 12.6833C3.97227 12.6833 3.76116 12.5944 3.58338 12.4166C3.4056 12.2388 3.31672 12.0306 3.31672 11.7919C3.31672 11.5528 3.4056 11.3444 3.58338 11.1666L6.78338 7.9666L3.56672 4.7666C3.38894 4.58882 3.30005 4.38327 3.30005 4.14993C3.30005 3.9166 3.38894 3.71105 3.56672 3.53327C3.74449 3.35549 3.95272 3.2666 4.19138 3.2666C4.43049 3.2666 4.63894 3.35549 4.81672 3.53327L8.00005 6.69993L11.15 3.54993C11.3278 3.37216 11.5389 3.28327 11.7834 3.28327C12.0278 3.28327 12.2389 3.37216 12.4167 3.54993C12.5945 3.72771 12.6834 3.94149 12.6834 4.19127C12.6834 4.44149 12.5945 4.65549 12.4167 4.83327L9.25005 8.0166L12.4334 11.1999C12.6 11.3666 12.6834 11.5722 12.6834 11.8166C12.6834 12.061 12.6 12.2666 12.4334 12.4333C12.2667 12.5999 12.064 12.6833 11.8254 12.6833C11.5863 12.6833 11.3834 12.5999 11.2167 12.4333L8.03338 9.23327Z",
    fill: "#FF5334"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.1d562cf1ddc48c0a4073d60c19d59231.svg";
export { ForwardRef as ReactComponent };